import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-icon-arrow-back',
  templateUrl: './icon-arrow-back.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconArrowBackComponent {}
